import {Component, OnInit} from '@angular/core';
import {ChangePasswordComponent} from "@components/profile/change-password.component";
import {LogginedUser} from "@models/user.model";
import {AuthService} from "@shared/services/security/auth.service";
import {PersonalInfoComponent} from "@components/profile/personal-info.component";
import {PillTab, PillTabsComponent} from "@shared/components/pill-tabs/pill-tabs.component";

@Component({
    selector: 'app-profile',
    imports: [
        ChangePasswordComponent,
        PersonalInfoComponent,
        PillTabsComponent,
    ],
    standalone: true,
    templateUrl: './profile.component.html',
    styleUrl: './profile.component.scss'
})
export class ProfileComponent implements OnInit {

  user: LogginedUser

  readonly tabs: PillTab[] = [
    {id: 1, label: 'Personal Information'},
    {id: 2, label: 'Change Password'},
  ]
  activeTab = 1

  constructor(
    private authService: AuthService
  ) {
  }

  ngOnInit(): void {
    this.authService.loggedUser$.subscribe((user: LogginedUser) => {
      this.user = user
    })
  }

  get initials(): string {
    return `${this.user?.firstName?.charAt(0) ?? ''}${this.user?.lastName?.charAt(0) ?? ''}`
  }

}
